export const integer = (number: number): string => number.toFixed(0);
